import React, { Component } from 'react';

class Pen extends Component {
    render() {
        return (
            <div className="btn-wrap pen-btn-wrap d-flex flex-column">
                <button type="button" className="btn pen-on-off-btn">형광펜<br/>꺼짐</button>
                <button type="button" className="btn pen-remove-btn">형광펜<br/>지우기</button>
            </div>
        );
    }
}

export default Pen;